import { clsx } from 'clsx';

type Props = {
  className?: string;
  /** Fond sombre : « Bien » en blanc */
  inverse?: boolean;
  /** Admin : « Bien » en violet */
  admin?: boolean;
};

/** Wordmark BienLivrer — « Bien » navy (ou blanc), « Livrer » orange. */
export default function BrandWordmark({ className, inverse = false, admin = false }: Props) {
  const bien = admin
    ? 'text-violet-600'
    : inverse
      ? 'text-white'
      : 'text-navy-700';

  return (
    <span className={clsx('font-extrabold tracking-tight', className)}>
      <span className={bien}>Bien</span>
      <span className="text-primary-700">Livrer</span>
    </span>
  );
}
